import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';

const PRODUCT_REDIRECT_MAP: Record<string, string> = {
  '3f8b2f1b-3be2-4b82-b127-b7c55ce5c781': '2b682f51-eb3a-40ae-82ad-267b95d08247',
  'a918e895-064a-4201-bead-a613e7b7bcf5': '828e33c6-6731-4273-80cb-d8586f9ac5df',
  'abd4ee37-ac08-4e42-ae63-77c7c8515c59': 'b233386d-83e8-4e31-8fb6-f1994831176f',
  'cfdb1c17-7231-4329-aba6-59ae78d61eaa': '95ec2353-09b2-4875-aa9e-5d9b22aa17c2',
  'dbeead6c-90ab-435a-81f6-8d89d639235b': '7aa01e59-7637-41c1-ad26-538002ce7aad',
  'fed996a5-16b8-4f25-81b1-b29572c5d144': '96841980-dc0f-49f1-9ed3-85213046f1d3',
  '47e72668-18cc-4b64-83fc-8ca3f04cb174': '1d093a8a-f881-4a81-ab14-30231c600f46',
  'ad0616f4-c2d0-4464-85fb-8bb97ddd8f2e': '09de0532-a23b-40ca-9593-f51df5b5849b',
  'fee6d6aa-5d92-46d0-9748-6e02ea971249': '09de0532-a23b-40ca-9593-f51df5b5849b',
  '4023244f-b249-43b5-9d61-158dad2aa13e': 'bb99d152-cd0b-4bc8-8e00-4db884d978d9',
  '45b749ec-dc26-4cfb-a9a0-9c83a41fdd6b': '29e6ba55-a43c-4f5e-87c8-8a3c5e18c4f1',
  '734f4875-897d-43b2-bbf1-14817558fa2e': '663c21ef-23fa-4ee2-9ef7-460900b4572d',
  'adf92787-90d1-4319-8102-5629420b47dd': '663c21ef-23fa-4ee2-9ef7-460900b4572d',
  'e0ae1ec3-4034-45a6-9a56-073c1f3a4d0f': '1d129dc3-b9cf-46fc-8912-958f119487d3',
  '1cb11193-5a15-46fd-b826-184a332655e3': '3d7335ef-d947-40e7-a5d5-f15e83cec268',
  '23e95a6c-0666-439c-a612-a982c1f6a884': '3748a233-2eaa-4ebf-b396-4119cf819d1b',
  '6790580e-2ec9-41fc-96eb-cc6d30e9c603': '839998b9-e7fb-4c5e-be5c-4ee225d2a8bf',
  '75723e36-a575-4c57-bfec-7c62ff23d5a2': '226edc88-7d77-4662-bee0-bee56d61d583',
  'b72781a9-76a5-4611-8a84-4f9e7ee070ee': '7c2361ab-d044-4db0-a969-2590f3a2be39',
  '9b3fc3bf-5f49-4944-9d88-b33b2c869cda': 'b9047806-0200-4e5d-ad37-3b0b66c3f056',
};

export const productRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const productUuid = route.paramMap.get('productUuid');
  const dealId = route.paramMap.get('dealId');

  if (productUuid && PRODUCT_REDIRECT_MAP[productUuid]) {
    // If the productUuid is in our map, redirect to the new productUuid
    // while preserving the dealId
    const redirectUrl = state.url.replace(`/${dealId}/product/${productUuid}`, `/${dealId}/product/${PRODUCT_REDIRECT_MAP[productUuid]}`);

    router.navigateByUrl(redirectUrl);
    return false; // Prevents the current navigation
  }

  // If no redirect is needed, allow the navigation
  return true;
};
